import React, { useState } from 'react'
import { Alert, Box, Typography } from '@mui/material'
import DropzoneS3Uploader from 'react-dropzone-s3-uploader'
import ProgressState from '../PolicyDetails/Components/PolicyDocuments/ProgressState'
import { getS3BucketSignedUrlForPolicyDcpDocuments } from '../../../../../lib/requests.es6'

const S3_URL = 'https://policy-onboarding-documents.s3.amazonaws.com'

// The evidence behind an AML/PEP decision. Uploading files it to the policy
// documents under the screening label, which is also what satisfies the
// decision gate — see lib/flaggedPolicyDecision.
const SupportingDocumentUpload = props => {
  const [progress, setProgress] = useState(0)
  const [error, setError] = useState(null)

  const handleFinish = info => {
    const url = info.fileUrl.replace('undefined', info.bucketKey)
    props.uploadDocument({
      policy_guid: props.policyGuid,
      description: props.label,
      filename: props.label,
      url
    })
    setProgress(100)
    // The uploader does not name the field consistently across the shapes it
    // reports, so fall back through them rather than showing "undefined".
    const filename =
      info.filename || (info.file && info.file.name) || props.label
    props.onUploaded({ filename, url })
  }

  const uploadOptions = {
    getSignedUrl: (file, callback) =>
      getS3BucketSignedUrlForPolicyDcpDocuments(
        props.policyGuid,
        file,
        callback
      ),
    s3Url: S3_URL,
    uploadRequestHeaders: {},
    onProgress: setProgress,
    onError: setError
  }

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {props.required === false
          ? 'Supporting document (optional)'
          : 'Supporting document (required)'}
      </Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>
        Upload the PDF evidence behind this decision.
      </Typography>
      {props.existingDocument && !props.uploadedFile ? (
        <Alert severity="success" sx={{ mb: 1 }}>
          {`${props.label} already attached to this policy. Upload another one to replace it.`}
        </Alert>
      ) : null}
      <Box
        sx={{
          border: props.satisfied ? '1px dashed #cbd5e0' : '1px dashed #e53e3e',
          borderRadius: 1,
          p: 1,
          backgroundColor: '#f9f9f9'
        }}
      >
        <DropzoneS3Uploader
          onFinish={handleFinish}
          upload={uploadOptions}
          s3Url={S3_URL}
          passChildrenProps={false}
          maxSize={1024 * 1024 * 10}
          accept=".pdf,application/pdf"
          style={{
            width: '100%',
            minHeight: '100px',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            borderRadius: '8px'
          }}
        >
          <Box sx={{ textAlign: 'center', py: 1 }}>
            <ProgressState progress={progress} errorMessage={error} />
          </Box>
        </DropzoneS3Uploader>
        {props.uploadedFile ? (
          <Alert severity="success" sx={{ mt: 1 }}>
            {`File successfully uploaded: ${props.uploadedFile.filename}`}
          </Alert>
        ) : null}
      </Box>
    </Box>
  )
}

export default SupportingDocumentUpload
